function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 89 86"
}, props), React.createElement("path", {
  d: "M68.646 8.257c-2.84 3.394-3.085 7.862-.554 9.985 2.538 2.122 6.888 1.087 9.728-2.307s3.085-7.863.554-9.985c-2.538-2.122-6.887-1.087-9.728 2.307z",
  stroke: "#5FB9D7",
  strokeWidth: "3",
  strokeMiterlimit: "10"
}), React.createElement("path", {
  d: "M70.793 13.954v-.004c.035-.692.314-1.479.8-2.227 1.002.528 2.157.707 3.337.585-.151.248-.33.5-.538.75-1.148 1.377-2.432 1.81-3.102 1.81-.236 0-.326-.047-.347-.062a.23.23 0 01-.035-.052.806.806 0 01-.066-.178 2.074 2.074 0 01-.049-.622z",
  fill: "#D3ECF4",
  stroke: "#5FB9D7"
}), React.createElement("path", {
  d: "M36.031 12.956l.218-.217c1.476-1.47 4.514-3.928 8.278-3.928 3.763 0 6.795 2.464 8.27 3.928",
  stroke: "#5FB9D7",
  strokeWidth: "3",
  strokeMiterlimit: "10",
  strokeLinecap: "round"
}), React.createElement("path", {
  d: "M80.69 3.135c1.996-1.964 4.712-1.266 5.588 1.226 1.417 4.033 1.397 12.996-6.189 19.218-2.326 1.911-5.351 2.774-8.35 3.071-4.725.462-12.786-.171-20.681-7.428-.37-.336-.719-.698-1.075-1.047-.823-.818-3.051-2.782-5.483-2.782-2.432 0-4.666 1.964-5.483 2.782-.356.349-.706.711-1.075 1.047-7.895 7.257-15.95 7.89-20.681 7.428-2.999-.296-6.024-1.16-8.35-3.071C1.324 17.357 1.304 8.394 2.72 4.36c.877-2.492 3.593-3.19 5.59-1.226",
  stroke: "#5FB9D7",
  strokeWidth: "3",
  strokeMiterlimit: "10",
  strokeLinecap: "round"
}), React.createElement("path", {
  d: "M20.928 18.306c2.535-2.12 2.29-6.589-.547-9.981-2.838-3.393-7.193-4.424-9.728-2.303-2.535 2.12-2.29 6.59.547 9.982 2.838 3.392 7.193 4.423 9.728 2.302z",
  stroke: "#5FB9D7",
  strokeWidth: "3",
  strokeMiterlimit: "10"
}), React.createElement("path", {
  d: "M18.155 13.95h0v.004c.014.25-.007.463-.048.622a.806.806 0 01-.066.178.232.232 0 01-.035.052c-.021.015-.111.063-.347.063-.67 0-1.954-.434-3.102-1.81a6.39 6.39 0 01-.539-.751c1.18.122 2.335-.057 3.339-.585.485.748.764 1.535.798 2.227z",
  fill: "#D3ECF4",
  stroke: "#5FB9D7"
}), React.createElement("path", {
  d: "M25.031 26.172s5.352.93 6.558 12.621c.244 2.38.843 4.732 1.885 6.887.6 1.246 1.397 2.55 2.432 3.737 0 0-1.621 10.354 1.568 14.638l-.408.494a6.219 6.219 0 00-1.14 5.774l4.073 13.234H44.5M63.977 26.172s-5.352.93-6.558 12.621c-.244 2.38-.844 4.732-1.885 6.887-.6 1.246-1.397 2.55-2.432 3.737 0 0 1.621 10.354-1.569 14.638l.41.494a6.219 6.219 0 011.14 5.774l-4.074 13.234h-4.501",
  stroke: "#5FB9D7",
  strokeWidth: "3",
  strokeMiterlimit: "10",
  strokeLinecap: "round"
}), React.createElement("path", {
  d: "M48.02 22.507h0c2.61 2.396 5.246 4.156 7.81 5.443-.457.845-.881 1.807-1.263 2.884-7.217.043-13.76 2.925-18.575 7.582a8.015 8.015 0 01-.008-.07c-.476-4.633-1.558-7.975-2.868-10.395 2.564-1.288 5.2-3.048 7.81-5.443h0c.344-.317.673-.646.993-.967l.004-.004h0l.203-.203h.001a7.267 7.267 0 011.45-1.13c.46-.267.773-.352.892-.352.12 0 .433.085.894.352.438.253.95.634 1.456 1.136 0 0 0 0 0 0l.217.217h0l.003.004.19.186c.257.253.52.512.79.76z",
  fill: "#D3ECF4",
  stroke: "#5FB9D7"
}), React.createElement("path", {
  d: "M37.508 64.053s2.142 1.595 5.22 1.595M51.548 64.053s-2.142 1.595-5.22 1.595M44.5 59.602V48.398",
  stroke: "#5FB9D7",
  strokeWidth: "3",
  strokeMiterlimit: "10",
  strokeLinecap: "round"
})));